import React, { useState, useEffect } from "react";
import { sendData, getData } from "../../../services/auth";
import { uriList } from "../../../helpers/config";
import { Button } from "reactstrap";
import { width, generateId, posicoes } from "../../../helpers";


import { confirmSwal, swalError } from "../../../helpers/swal";
import * as moment from "moment";
import { Aguarde, getCookie } from '../../../helpers/general'

import { useSelector } from "react-redux";
import InclusaoIntegracoes from "./InclusaoIntegracoes";
import { Pagination, InputLabelAlert, DropDownMenu } from '../../../common/layout'

const dataIni = { id: 0, descricao: "", file: null }

const Integracoes = (props) => {
    const [allIntegracoes, setAllIntegracoes] = useState([]);
    const [Integracoes, setIntegracoes] = useState([]);
    const [modal, setModal] = useState(false);
    const [data, setData] = useState(dataIni);
    const _login = useSelector((state) => state.login);
    const [excluindo, setExcluindo] = useState(false)
    const [carregando, setCarregando] = useState(false)
    const [actualPage, setActualPage] = useState(0)
    const [pesquisa, setPesquisa] = useState("")
    const [clientes, setClientes] = useState([])
    const [pessoas, setPessoas] = useState([])
    const [colaboradores, setColaboradores] = useState([])
    const [qtdLinesPage, setQtdLinesPage] = useState(getCookie({ label: "qtdLinesPage" }) || 10)
    const [posicao, setPosicao] = useState(props.posicao)
    const [gerandoDossie, setGerandoDossie] = useState(false)
    let agrupamento = {}, grupo

    async function _getData(_integracao = true) {
        console.log("Integracoes._getData(0): ", _login)

        setData(null)
        setCarregando(true)

        if (colaboradores?.length == 0 || !colaboradores) {
            await sendData({ uri: uriList("buscarPessoas"), content: { onlySimpleFields: true } })
                .then((_res) => {
                    const res = _res.data || _res
                    console.log("InclusaoIntegracoes.buscarPessoas(teste): ", res);

                    if (res) {

                        setClientes(res?.filter(item => item.CLIENTE == "SIM"))
                        setColaboradores(res?.filter(item => item.COLABORADOR == "SIM" || item.EMPRESA == "SIM"))
                        setPessoas(res || [])
                    }
                })
                .catch((e) => {
                    console.log(e);
                    alert("Erro ao buscarClientes.\n" + e.message);
                });
        }

        if (_integracao)
            await sendData({ uri: uriList("integracoes"), content: { empresaid: _login.empresaid || 0 } })
                // sendData({ uri: uriList("listIntegracoes"), })
                .then((_res) => {
                    setCarregando(false)
                    const res = _res.data || _res
                    console.log("Integracoes: ", res);

                    if (res) {
                        setAllIntegracoes(res)
                        let _data = res
                        if (posicao || pesquisa)
                            filtrarRegistros()
                        else
                            setIntegracoes(_data)
                    }
                })
                .catch((e) => {
                    setCarregando(false)
                    console.log(e);
                    // alert("Erro ao obter Integracoes.\n" + e.message);
                });
    }

    // useEffect(() => {
    //     _getData(false);
    // }, []);

    useEffect(() => {
        filtrarRegistros()
    }, [posicao, pesquisa])

    async function closeModal(_refresh = false) {
        handleLimparFiltros()
        setModal(false)
        if (!modal?.edit && _refresh)
            await _getData();
    }

    async function handleDelete(element) {
        async function callback(p) {
            console.log("Integracoes.handleDelete: ", element)
            if (p) {
                let uri = uriList("integracoesDel")
                console.log("Integracoes.handleDelete(uri): ", uri)
                setExcluindo(true)

                await sendData({ uri, content: { id: element.ID } })
                    .then((res) => {
                        console.log("Integracoes - Deletado: ", res);
                        setExcluindo(false)
                        if (res.status && parseInt(res.status) > 200) {
                            // swalError({
                            //     title: `Erro ao excluir registro! \n${res.data || res.message || res.erro}`,
                            // });
                            return
                        }

                        _getData();
                    })
                    .catch(error => {
                        console.log(error);
                        setExcluindo(false)
                        // swalError({
                        //     title: `Erro ao excluir registro! \n${error.message}`,
                        // });
                    })
            }
        }

        confirmSwal({ callback, title: "Confirma a execução do processo?" });
    }

    async function handleAtivar(element) {
        console.log("index.handleAtivar(0)")
        function callback(p) {
            console.log("Integracoes.handleAtivar: ", element)
            if (p) {
                console.log("Integracoes.handleAtivar(1)")
                sendData({ uri: uriList("integracoesAtivar"), content: { id: element.ID, pessoaid: element.PESSOAID } })
                    .then((res) => {
                        console.log("Integracoes - handleAtivar: ", res);
                        if (res.status && parseInt(res.status) > 200) {
                            swalError({
                                title: `Erro ao ativar! \n${res.data || res.message || res.erro || res}`,
                            });
                            return
                        }
                        _getData()
                    })
                    .catch(error => {
                        console.log("Integracoes - handleAtivar(erro): ", error);
                        // console.log(error);
                        swalError({
                            title: `Erro ao ativar! \n${error.message}`,
                        });
                    })
            }
        }

        confirmSwal({ callback, title: "Confirma a execução do processo?" });
    }

    function handlePage(e) {
        setActualPage(e.currentTarget.value);
    }

    async function handleEditEmpresaInt(element) {
        await sendData({ uri: uriList("getIntegracaoEmpresa"), content: element })
            .then((res) => {
                console.log("Integracoes: ", res?.data || res);

                if (res.status && parseInt(res.status) > 200) throw new Error();
                else {
                    setData(res?.data || res)
                    setModal({ edit: true });
                }
            })
            .catch((e) => {
                console.log(e);
            });

        console.log("IntegraçõesList.handleEditEmpresaInt: ", element)
    }

    function handleEdit(e) {
        console.log("IntegraçõesList.handleEdit(e): ", e)
        setData(e)
        setModal({ edit: true });
    }

    function handleEmail(element) {
        function callback(p) {
            console.log("Integracoes.handleEmail: ", element)
            if (p) {
                setExcluindo(true)
                sendData({ uri: uriList("integracoesSend"), content: { ...element, } })
                    .then((res) => {
                        console.log("Integracoes - Enviado: ", res);
                        setExcluindo(false)
                        if (res.status && parseInt(res.status) > 200) {
                            swalError({
                                title: `Erro ao excluir registro! \n${res.data || res.message || res.erro}`,
                            });
                            return
                        }

                        _getData();
                    })
                    .catch(error => {
                        console.log(error);
                        setExcluindo(false)
                        swalError({
                            title: `Erro ao enviar email! \n${error.message}`,
                        });
                    })
            }
        }

        confirmSwal({ callback, title: "Confirma o envio dos documentos?" });
    }

    function gerarDossie(element) {
        function callback(e) {
            if (e) {
                setGerandoDossie(true)
                sendData({ uri: uriList("gerarDossie"), content: { id: element.ID || data.id, uploadS3: true } })
                    .then((res) => {
                        if (res.status && parseInt(res.status) > 200) throw new Error();
                        console.log("InclusaoIntegracoes.gerarDossie(ok): ", res.data)
                        if (res?.data?.url)
                            setData({ ...data, URL_ARQUIVO: res?.data?.url })
                        // setDocumentos(res.data)
                        setGerandoDossie(false)
                    })
                    .catch((e) => {
                        console.log(e);
                        console.log("InclusaoIntegracoes.gerarDossie(error)")
                        setGerandoDossie(false)
                        // alert("Erro ao obter Documentos.\n" + e.message);
                    });
            }
        }

        confirmSwal({ callback, title: "Confirma a geração do Dossiê?" });
    }

    function filtrarRegistros() {
        if (pesquisa || posicao) {
            let _pesquisa = pesquisa.toLowerCase()
            let _docs = allIntegracoes.filter(e =>
                (!pesquisa || e.PESSOA?.toLowerCase().indexOf(_pesquisa) >= 0 || e.CLIENTE?.toLowerCase().indexOf(_pesquisa) >= 0 ||
                    e.CLIENTE_CNPJ?.toLowerCase().indexOf(_pesquisa) >= 0 || e.CIDADE?.toLowerCase().indexOf(_pesquisa) >= 0) &&
                (!posicao || e.POSICAO == posicao || (posicao == 'VALIDO' && ['VENCENDO', 'ATIVO'].indexOf(e.POSICAO) >= 0))
            )
            setIntegracoes(_docs)
            setActualPage(0);
        }
        else
            setIntegracoes(allIntegracoes)

    }
    function handlePesquisa(e) {
        setPesquisa(e.target.value)
    }

    function handleLimparFiltros() {
        setPesquisa("")
        handlePosicao(null)
    }

    function handlePosicao(e) {
        setPosicao(e?.target?.value)
    }


    return (
        <div style={{ height: "80vh", }}>
            {modal &&
                <InclusaoIntegracoes
                    onCloseEv={closeModal}
                    empresa={_login.empresaid}
                    clientes={clientes}
                    pessoas={colaboradores}
                    data={!modal.insert && data}
                    setData={(data) => Integracoes.map((item, index) => {
                        console.log("Integracoes.index(setData - Edição): ", data)
                        console.log("Integracoes.index(setData - Edição): ", { item, data })
                        if (item.ID == data.ID)
                            Integracoes[index] = { ...item, ...data }
                    })}
                    update />
            }
            <div className="col-md-12 mb-5">
                <div className={`${width() == "mobile" ? "h3" : "h1"} center-elements`}>Integrações</div>
            </div>

            <div
                style={{
                    flexDirection: width() == "mobile" ? "column" : "",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    overflowY: "auto",
                    height: "75vh",
                }}
            >
                <div data-d="" className="col-md-12 mb-2">
                    <div className={`${width() == "mobile" ? "col-12" : "col-3 p-0"} d-flex align-items-center justify-content-left mb-3`}>
                        <button className="btn btn-secondary"
                            onClick={e => {
                                if (props.onCloseEv)
                                    props?.onCloseEv()
                            }}

                        >
                            <i className="fa fa-window-close"></i>
                        </button>
                        <button className="btn btn-primary ml-1" onClick={() => {
                            setModal({ insert: true });
                        }} disabled={carregando}>
                            <i className="fa fa-plus-circle"></i>
                        </button>
                    </div>
                    <div className={`p-0 ${width() == "mobile" ? "d-block" : "d-flex"} `}>
                        <div className={`${width() == "mobile" ? " col-12" : "col-3 p-0"} `}>
                            <InputLabelAlert
                                type="text"
                                label="Pesquisa"
                                id="pesquisa"
                                cifrao={false}
                                value={pesquisa}
                                handle={handlePesquisa}
                                focus={true}
                            />
                        </div>
                        <div className={`${width() == "mobile" ? " col-12" : "col-2 ml-2 p-0"} `}>
                            <label className="m-0 font-90">Posição</label>
                            <select className="form-control" onChange={handlePosicao} >
                                <>
                                    <option value="" selected={!posicao}>Todos...</option>
                                    {posicoes?.map((item, key) => {
                                        return (
                                            <option key={key} value={item.posicao} selected={posicao == item.posicao}>{item.descricao}</option>
                                        )
                                    })}
                                </>
                            </select>
                        </div>
                        <div className={`${width() == "mobile" ? " col-12 mb-2" : "col-4 ml-2 p-0"} `}>
                            <div className="mt-3">
                                <button className={`${width() == "mobile" ? "" : "ml-1 "} btn btn-primary `} onClick={_getData} >
                                    Pesquisar
                                </button>

                                <button className={`${width() == "mobile" ? "" : "ml-1 "} btn btn-secondary `} onClick={handleLimparFiltros} >
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12" style={{ overflowX: "auto" }}>
                    <div >

                        <table className="table table-striped table-hover rounded" >
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>#</th>
                                    {/* {!props.empresa && <th scope="col">Cliente</th>} */}
                                    <th scope="col" style={{ width: "80%" }}>Pessoa(Colaborador/Empresa)</th>
                                    {/* <th scope="col" style={{ width: "10%" }}>Status</th> */}
                                    <th scope="col" style={{ width: "10%" }}>Validade</th>
                                    <th
                                        scope="col"
                                        className="text-center"
                                        style={{ width: "5%" }}
                                    >
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!Integracoes && <tr>Carregando...</tr>}
                                {Integracoes?.map((doc, index) => {
                                    if (agrupamento?.nome != doc.CLIENTE + doc.CLIENTE_CNPJ) {
                                        agrupamento.nome = doc.CLIENTE + doc.CLIENTE_CNPJ
                                        grupo = true
                                        // console.log("Integracoes.index(grupo): ", { grupo, agrupamento })
                                    }
                                    else
                                        grupo = false

                                    // if (doc.EMPRESAINT)
                                    //     doc.EMPRESAINTDOC = Integracoes.filter(e => e.ID == doc.EMPRESAINT)[0]

                                    return (
                                        <>
                                            {grupo &&
                                                index >= actualPage * 10 &&
                                                index < (actualPage + 1) * 10 &&
                                                <tr style={{ fontWeight: "bold", textDecoration: "underline" }}>
                                                    <td colspan="5">
                                                        <div className="d-flex">
                                                            <span style={{ cursor: "pointer" }}
                                                                onDoubleClick={e => handleEditEmpresaInt(doc)}>
                                                                {`${doc.CLIENTE} - ${doc.CIDADE || ''} (${doc.CLIENTE_CNPJ})`}
                                                            </span>
                                                            <Button
                                                                className="btn btn-sm ml-4  inbtn d-flex justify-content-center align-items"
                                                                type="button"
                                                                title="Enviar email do dossiê"
                                                                onClick={e => handleEmail(doc)}>
                                                                <i className="fa fa-envelope" />
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                            {index >= actualPage * qtdLinesPage &&
                                                index < (actualPage + 1) * qtdLinesPage &&
                                                (
                                                    <tr style={{
                                                        cursor: "pointer", textDecoration: doc.ATIVA == "SIM" ? "underline" : ["VENCIDO", "INATIVO", "VENCENDO"].indexOf(doc.POSICAO) >= 0 ? "line-through" : "",
                                                        textDecorationStyle: ["VENCIDO", "INATIVO"].indexOf(doc.POSICAO) >= 0 ? "double" : "",
                                                        color: doc.ATIVA == "SIM" ? "#0C4674" : ["VENCIDO", "INATIVO"].indexOf(doc.POSICAO) >= 0 ? "red" : doc.POSICAO == "VENCENDO" ? "orange" : ""
                                                    }} onDoubleClick={() => handleEdit(doc)}
                                                        title={doc.ATIVA == "SIM" ? "Integração Ativa" : ""}>
                                                        <th scope="row" style={{ width: "5%" }}>{index + 1}</th>
                                                        {/* <td style={{ maxWidth: "150px" }}>{doc.CLIENTE}</td> */}
                                                        <td style={{ width: "80%" }}>{doc.PESSOA}</td>
                                                        {/* <td style={{ width: "10%" }}>{doc.STATUS}</td> */}
                                                        <td style={{ width: "10%" }}>{moment(doc.VALIDADE).format('DD/MM/YYYY')}</td>
                                                        <td style={{ width: "5%" }}>
                                                            <div className="d-flex justify-content-center " style={{ overflow: 'hidden', }}>
                                                                <DropDownMenu items={[
                                                                    { descricao: "Editar", onClick: e => handleEdit(doc), className: "fa fa-edit", title: "Editar a Integração" },
                                                                    { descricao: "Excluir", onClick: e => handleDelete(doc), className: "fa fa-trash", title: "Excluir a Integração", color: "red" },
                                                                    {
                                                                        descricao: "Ativar", onClick: e => handleAtivar(doc), className: "fa fa-star",
                                                                        title: "Ativa a integração para o colaborador", color: "#0C4674", separatorTop: true, invisible: doc.ATIVA == "SIM"
                                                                    },
                                                                    { descricao: "Gerar Dossiê", onClick: e => gerarDossie(doc), className: "fa fa-cogs", title: "Faz a geração do dossiê de documentos da integração", },
                                                                ]} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                        </>
                                    )
                                }
                                )
                                }
                            </tbody>
                            {/* <tfoot> */}
                            <tr>
                                <td colSpan="12" className="text-left">
                                    Total de Registros: {Integracoes && Integracoes.length}
                                </td>
                            </tr>
                            {/* </tfoot> */}
                        </table>
                        <Pagination
                            detailed={Integracoes}
                            actual={actualPage}
                            changePage={handlePage}
                            setQtdLinesPage={setQtdLinesPage}
                        />
                    </div>
                </div>
            </div>

            {excluindo && <Aguarde />}
            {carregando && <Aguarde legenda="Aguarde, carregando registros..." />}
            {gerandoDossie && <Aguarde legenda="Aguarde, gerando dossiê..." />}
        </div>
    );
}

export default Integracoes;

